<template>
  <modal
    :headline="$t('changeInitialPasswordModal.headline')"
    :description="$t('changeInitialPasswordModal.description')"
    class="ce-changeInitialPassword"
    :closable="false">
    <div class="ce-modalContent">
      <alert
        class="mb3"
        v-if="hasMessage"
        :message="message.content"
        :type="message.type"
        :closable="false" />

      <v-form
        @submit="submit">
        <password-field
          name="password"
          :label="$t('changeInitialPasswordModal.password')" />

        <div>
          <button
            class="ce-btn ce-btn-light ce-btn--fullWidth"
            type="submit">
            <template v-if="loading">
              <fa-icon
                icon="spinner"
                spin />
            </template>
            <template v-else>
              {{ $t('changeInitialPasswordModal.submit') }}
            </template>
          </button>
        </div>
      </v-form>
    </div>
  </modal>
</template>

<script>
import PasswordField from 'components/forms/PasswordField.vue';

export default {
  components: { PasswordField },
  data() {
    return {
      loading: false,
      message: {
        type: 'success',
        content: null
      }
    };
  },
  computed: {
    hasMessage() {
      return this.message && this.message.content;
    }
  },
  methods: {
    async submit(values) {
      this.loading = true;

      try {
        await this.$store.dispatch('user/changePassword', values.password);
      } catch (e) {
        if (e.response?.data?.message === 'invalidPasswordHistoryMessage') {
          this.message = {
            content: this.$t('userProfile.personalData.error.invalidPasswordHistoryMessage'),
            type: 'error',
          };
        } else {
          this.message = {
            content: this.$t('generic.unknownError'),
            type: 'error'
          };
        }
      }

      this.loading = false;
    }
  }
};
</script>

<style lang="less">
  @import (reference) '~styles/includes/base';
</style>
